import {
  CustomerFacingCheckOutModel,
  MerchantAccount,
} from "@mindmemobile/mm-payment-modules";
import {
  ColorSwatches,
  DonationAmountSelection,
  DonationFormType,
  DonationPopupModalType,
  FundRaiserRedirectType,
  FundRaiserStatus,
  FundRaiserTemplateLayoutType,
  IconType,
  LegalTermsAndConditionType,
  MediaType,
  RedirectOtherFundraiserType,
} from "../enums";
import {
  IAPIDonationItem,
  IAPIFundraiserGridModel,
  IAPIGetFundraiserPublicViewResponseModel,
  IDonationAndPaymentIAPIResponse,
  IFundImpactAPIResponse,
  IFundRaiserPageDesign,
  IFundRaiserRedirectValue,
  IPromoter,
  IRewardByAmount,
  IRewardByRank,
  RankAchievement,
} from "../interfaces";
import { DonationItemModel } from "./DonationModels";
import {
  CreateFundraiserModel,
  FundraisersDonationsBoardResponse,
  FundraiserCustomColorConfig,
  FundraiserSectionVisibilityModel,
  FundRaiserStatsModel,
  CategoryModel,
} from "./FundraiserModels";
import { ColorModel, MediaModel } from "./GalleryModels";
import { ListInterestTagModel } from "./ListInterestTagModels";
import { PromoterProgressModel } from "./PromoterModels";
export class LayoutDataModel {
  selectedLayout?: keyof typeof FundRaiserTemplateLayoutType;
  sectionVisibility?: Record<string, boolean>;
  layoutZones?: Record<string, string[]>;
  progressLayout?: string;
  customColors?: Record<string, string>;
  selectedColorSwatch?: string;
  donationButtonType?: string;
  donationButtonColors?: Record<string, string>;

  //showHeader: boolean;
  showCampaignProgress: boolean;
  showPromotersProgress: boolean;
  showImpactStats: boolean;
  showMissionSection: boolean;
  showHeroMedia: boolean;
  showDonationForm: boolean;
  showLeaderBoard: boolean;
  totalLeadBoards: number;
  totalLastDonations: number;
  showDonationComments: boolean;
  showRecentDonations: boolean;
  showCallToAction: boolean;
  colorSwatch: keyof typeof ColorSwatches;
  showStats: boolean;
  showProgress: boolean;
  fundRaiserProgress: boolean;
  promoterProgress: boolean;
  sideBySideProgress: boolean;
  constructor(data?: Partial<LayoutDataModel>) {
    this.selectedLayout =
      data?.selectedLayout ?? FundRaiserTemplateLayoutType.Layout1;
    this.sectionVisibility = data?.sectionVisibility ?? {};
    this.layoutZones = data?.layoutZones ?? {};
    this.progressLayout = data?.progressLayout ?? "";
    this.customColors = data?.customColors ?? {};
    this.selectedColorSwatch = data?.selectedColorSwatch ?? "";
    this.donationButtonType = data?.donationButtonType ?? "";
    this.donationButtonColors = data?.donationButtonColors ?? {};

    //NEW PROPEPRTIES
    this.showCampaignProgress = data?.showCampaignProgress ?? true;
    this.showPromotersProgress = data?.showPromotersProgress ?? true;
    this.showImpactStats = data?.showImpactStats ?? true;
    this.showMissionSection = data?.showMissionSection ?? true;
    this.showHeroMedia = data?.showHeroMedia ?? true;
    this.showDonationForm = data?.showDonationForm ?? true;
    this.showLeaderBoard = data?.showLeaderBoard ?? true;
    this.totalLeadBoards = data?.totalLeadBoards ?? 5;
    this.totalLastDonations = data?.totalLastDonations ?? 5;
    this.showDonationComments = data?.showDonationComments ?? true;
    this.showRecentDonations = data?.showRecentDonations ?? true;
    this.showCallToAction = data?.showCallToAction ?? true;
    this.colorSwatch = data?.colorSwatch ?? ColorSwatches.Default;
    this.showStats = data?.showStats ?? true;
    this.showProgress = data?.showProgress ?? true;
    this.fundRaiserProgress = data?.fundRaiserProgress ?? true;
    this.promoterProgress = data?.promoterProgress ?? false;
    this.sideBySideProgress = data?.sideBySideProgress ?? false;
  }

  static deserializeAPIModel(data: IFundRaiserPageDesign): LayoutDataModel {
    return new LayoutDataModel({
      selectedLayout: data.layout,
      showCampaignProgress: data.showCampaignProgress,
      showPromotersProgress: data.showPromotersProgress,
      showImpactStats: data.showImpactStats,
      showMissionSection: data.showMissionSection,
      showHeroMedia: data.showHeroMedia,
      showDonationForm: data.showDonationForm,
      showLeaderBoard: data.showLeaderBoard,
      totalLeadBoards: data.totalLeadBoards,
      totalLastDonations: data.totalLastDonations,
      showDonationComments: data.showDonationComments,
      showRecentDonations: data.showRecentDonations,
      showCallToAction: data.showCallToAction,
      colorSwatch: data.colorSwatch,
      showStats: data.showStats,
      showProgress: data.showProgress,
      fundRaiserProgress: data.fundRaiserProgress,
      promoterProgress: data.promoterProgress,
      sideBySideProgress: data.sideBySideProgress,
      //selectedLayout: data.layout,
      // sectionVisibility: data.sectionVisibility,
      //layoutZones: data.layoutZones,
      //progressLayout: data.progressLayout,
      //customColors: data.customColors,
      //selectedColorSwatch: data.selectedColorSwatch,
      //donationButtonType: data.donationButtonType,
      // donationButtonColors: data.donationButtonColors,
    });
  }
}

export class ImpactModel {
  id: string;
  icon: string;
  color: ColorModel;
  number: string;
  description: string;
  order: number;

  constructor(data?: Partial<ImpactModel>) {
    this.id = data?.id ?? "";
    this.icon = data?.icon ?? "";
    this.color = data?.color
      ? new ColorModel(data?.color)
      : new ColorModel({ hex: "#000000" });
    this.number = data?.number ?? "";
    this.description = data?.description ?? "";
    this.order = data?.order ?? 0;
  }

  static deserializeAPIModel(
    data: IFundImpactAPIResponse,
    order?: number
  ): ImpactModel {
    return new ImpactModel({
      id: "",
      icon: data.icon || "",
      color: ColorModel.deserializeAPIModel(data.color),
      number: data.value || "",
      description: data.description || "",
      order: order || 0,
    });
  }
}

export class RewardModel {
  id: string;
  level: number;
  reward: string;
  order: number;
  isEditing?: boolean;
  isNew?: boolean;

  constructor(data?: Partial<RewardModel>) {
    this.id = data?.id ?? "";
    this.level = data?.level ?? 0;
    this.reward = data?.reward ?? "";
    this.order = data?.order ?? 0;
    this.isEditing = data?.isEditing ?? false;
    this.isNew = data?.isNew ?? false;
  }

  static deserializeAPIModel(
    data: IRewardByAmount,
    level: number
  ): RewardModel {
    return new RewardModel({
      id: level.toString(),
      level: data.amount,
      reward: data.reward,
      order: level,
      isEditing: false,
      isNew: false,
    });
  }
}

export class RankAchievementModel {
  id: string;
  rank: string;
  reward: string;
  minimum?: number;
  order: number;
  isEditing?: boolean;
  isNew?: boolean;

  constructor(data?: Partial<RankAchievementModel>) {
    this.id = data?.id ?? "";
    this.rank = data?.rank ?? "";
    this.reward = data?.reward ?? "";
    this.minimum = data?.minimum ?? 0;
    this.order = data?.order ?? 0;
    this.isEditing = data?.isEditing ?? false;
    this.isNew = data?.isNew ?? false;
  }

  static deserializeAPIModel(apiModel: IRewardByRank, index: number) {
    const start = Number(apiModel?.startingRank ?? 0);
    const end = Number(apiModel?.endingRank ?? 0);

    const rankString =
      start && end && start !== end ? `${start}-${end}` : `${start}`;

    return new RankAchievementModel({
      id: index.toString(),
      rank: rankString,
      reward: apiModel?.reward ?? "",
      minimum: apiModel?.minimumAmount ?? 1,
      isEditing: false,
      order: index,
      isNew: false,
    });
  }
}

export class FundRaiserListInterestTagsModel {
  id: string;
  name: string;

  constructor(data?: Partial<FundRaiserListInterestTagsModel>) {
    this.id = data?.id ?? "";
    this.name = data?.name ?? "";
  }

  static deserializeAPIModel(
    data: FundRaiserListInterestTagsModel
  ): FundRaiserListInterestTagsModel {
    return new FundRaiserListInterestTagsModel(data);
  }
}
export class FundRaiserRedirectValueModel {
  id: string;
  name: string;
  url: string;

  constructor(data?: Partial<FundRaiserRedirectValueModel>) {
    this.id = data?.id ?? "";
    this.name = data?.name ?? "";
    this.url = data?.url ?? "";
  }

  static deserializeAPIModel(
    data: IFundRaiserRedirectValue
  ): FundRaiserRedirectValueModel {
    return new FundRaiserRedirectValueModel(data);
  }
}

export class DonationAndPaymentModel {
  donationItems: DonationItemModel;
  showPopUp: boolean;
  restrictions: boolean;
  minimumAmount: number;
  maximumAmount: number;
  donationItem: boolean;
  redirect: boolean;
  lists: FundRaiserListInterestTagsModel[];
  interests: FundRaiserListInterestTagsModel[];
  tags: FundRaiserListInterestTagsModel[];
  redirectType: keyof typeof RedirectOtherFundraiserType;
  redirectValue: FundRaiserRedirectValueModel;

  constructor(data?: Partial<DonationAndPaymentModel>) {
    this.donationItems = data?.donationItems ?? new DonationItemModel();
    this.showPopUp = data?.showPopUp ?? false;
    this.restrictions = data?.restrictions ?? false;
    this.minimumAmount = data?.minimumAmount ?? 0;
    this.maximumAmount = data?.maximumAmount ?? 0;
    this.donationItem = data?.donationItem ?? false;
    this.redirect = data?.redirect ?? false;
    this.lists = data?.lists ?? [];
    this.interests = data?.interests ?? [];
    this.tags = data?.tags ?? [];
    this.redirectType =
      data?.redirectType ?? RedirectOtherFundraiserType.Gallery;
    this.redirectValue =
      data?.redirectValue || new FundRaiserRedirectValueModel();
  }

  static deserializeAPIModel(
    data: IDonationAndPaymentIAPIResponse
  ): DonationAndPaymentModel {
    return new DonationAndPaymentModel({
      showPopUp: data.showPopUp,
      restrictions: data.restrictions,
      minimumAmount: data.minimumAmount,
      maximumAmount: data.maximumAmount,
      donationItem: data.donationItem,
      redirect: data.redirect,
      lists: data.lists
        ? data.lists.map((item) =>
            FundRaiserListInterestTagsModel.deserializeAPIModel(item)
          )
        : [],
      interests: data.interests
        ? data.interests.map((item) =>
            FundRaiserListInterestTagsModel.deserializeAPIModel(item)
          )
        : [],
      tags: data.tags
        ? data.tags.map((item) =>
            FundRaiserListInterestTagsModel.deserializeAPIModel(item)
          )
        : [],
      redirectType: data.redirectType,
      donationItems: data.donationItemDetails
        ? DonationItemModel.deserialize(data.donationItemDetails)
        : new DonationItemModel(),
      redirectValue: data.redirectValue
        ? FundRaiserRedirectValueModel.deserializeAPIModel(data.redirectValue)
        : new FundRaiserRedirectValueModel(),
    });
  }
}

export class Fundraiser {
  id: string;
  name: string;
  title: string;
  pageName: string;
  description: string;
  subtitle?: string;
  goal: number;
  currentAmount: number;
  status: keyof typeof FundRaiserStatus;
  startDate: Date;
  endDate: Date;
  category: string;
  image?: MediaModel;
  mediaItems?: MediaModel[];
  totalDonations: number;
  activePromoters?: number;
  totalDonars?: number;
  averageDonation?: number;
  lastDonation?: Date;
  createdDate: Date;
  organizationName?: string;
  closeOnGoalAchieved?: boolean;
  increaseGoalOnAchieved?: boolean;
  redirectOnVisit?: keyof typeof RedirectOtherFundraiserType;
  redirectWebsiteUrl?: string;
  redirectMobilePage?: string;
  redirectOtherFundraiserType?: RedirectOtherFundraiserType;
  redirectSpecificFundraiserId?: string;
  donationAndPaymentDetails?: DonationAndPaymentModel;
  impact?: ImpactModel[];
  rewards?: RewardModel[];
  ranks?: RankAchievementModel[];
  stats?: FundRaiserStatsModel[];
  iconImageChoice?: keyof typeof IconType;
  fundraiserImage?: MediaModel | null;
  titleIcon?: string;
  titleColor?: ColorModel;
  layoutData?: LayoutDataModel;
  //public view properties
  donationsBoard?: FundraisersDonationsBoardResponse[];
  leaderboard?: PromoterProgressModel[];

  constructor(data?: Partial<Fundraiser>) {
    this.id = data?.id ?? "";
    this.name = data?.name ?? "";
    this.title = data?.title ?? "";
    this.description = data?.description ?? "";
    this.subtitle = data?.subtitle ?? "";
    this.pageName = data?.pageName || "";
    this.totalDonars = data?.totalDonars ?? 0;
    this.goal = data?.goal ?? 0;
    this.currentAmount = data?.currentAmount ?? 0;
    this.status = data?.status ?? FundRaiserStatus.Draft;
    this.startDate = data?.startDate ? new Date(data.startDate) : new Date();
    this.endDate = data?.endDate ? new Date(data.endDate) : new Date();
    this.category = data?.category ?? "";
    this.image = data?.image ? new MediaModel(data.image) : new MediaModel();
    this.mediaItems = data?.mediaItems ?? [];
    this.totalDonations = data?.totalDonations ?? 0;
    this.activePromoters = data?.activePromoters ?? 0;
    this.averageDonation = data?.averageDonation ?? 0;
    this.lastDonation = data?.lastDonation
      ? new Date(data.lastDonation)
      : undefined;
    this.createdDate = data?.createdDate
      ? new Date(data.createdDate)
      : new Date();
    this.donationAndPaymentDetails = new DonationAndPaymentModel(
      data?.donationAndPaymentDetails
    );
    this.organizationName = data?.organizationName ?? "";
    this.closeOnGoalAchieved = data?.closeOnGoalAchieved ?? false;
    this.increaseGoalOnAchieved = data?.increaseGoalOnAchieved ?? false;
    this.redirectOnVisit =
      data?.redirectOnVisit ?? RedirectOtherFundraiserType.ClosestGoal;
    this.redirectWebsiteUrl = data?.redirectWebsiteUrl ?? "";
    this.redirectMobilePage = data?.redirectMobilePage ?? "";
    this.redirectOtherFundraiserType =
      data?.redirectOtherFundraiserType ??
      RedirectOtherFundraiserType.ClosestGoal;
    this.redirectSpecificFundraiserId =
      data?.redirectSpecificFundraiserId ?? "";

    // Use nested models
    this.impact = data?.impact?.map((i) => new ImpactModel(i)) ?? [];
    this.rewards = data?.rewards?.map((r) => new RewardModel(r)) ?? [];
    this.ranks = data?.ranks?.map((rk) => new RankAchievementModel(rk)) ?? [];

    this.iconImageChoice = data?.iconImageChoice ?? IconType.None;
    this.fundraiserImage = data?.fundraiserImage
      ? new MediaModel(data.fundraiserImage)
      : null;
    this.titleIcon = data?.titleIcon ?? "";
    this.titleColor = data?.titleColor
      ? new ColorModel(data.titleColor)
      : new ColorModel({ hex: "#000000" });

    this.layoutData = data?.layoutData
      ? new LayoutDataModel(data.layoutData)
      : new LayoutDataModel();

    this.leaderboard = data?.leaderboard?.map(
      (l) => new PromoterProgressModel(l)
    );
    this.donationsBoard = data?.donationsBoard?.map(
      (d) => new FundraisersDonationsBoardResponse(d)
    );
    this.stats = data?.stats?.map((s) => new FundRaiserStatsModel(s)) || [];
  }

  getPrimaryImageToShow(): string {
    if (this.fundraiserImage?.fullURL) {
      return this.fundraiserImage.fullURL;
    }
    if (this.mediaItems && this.mediaItems.length > 0) {
      return (
        this.mediaItems.filter((m) => m.type === MediaType.Image)[0]?.fullURL ||
        ""
      );
    }
    return "";
  }

  static deserializeAPIModel(
    data: IAPIGetFundraiserPublicViewResponseModel
  ): Fundraiser {
    return new Fundraiser({
      id: data?.id ?? "",
      name: data.name ?? "",
      title: data.title ?? "",
      pageName: data.pageName ?? "",
      description: data.description ?? "",
      subtitle: data.subTitle ?? "",
      goal: data.marketing?.goalAmount ?? 0,
      currentAmount: data.totalRaisedAmount ?? 0,
      category: "",
      image: data.image
        ? MediaModel.deserializeAPIModel(data.image)
        : undefined,
      mediaItems: data.medias
        ? data.medias.map((media) => MediaModel.deserializeAPIModel(media))
        : [],
      totalDonations: data.totalDonations ?? 0,
      activePromoters: data.activePromoters ?? 0,
      totalDonars: data.totalDonors ?? 0,
      averageDonation: data.averageDonation ?? 0,
      organizationName: data.organizationName ?? "",
      closeOnGoalAchieved: data.marketing?.closeOnGoalAchieved ?? false,
      increaseGoalOnAchieved: data.marketing?.isIncreaseGoal ?? false,
      redirectOnVisit:
        data.donationAndPaymentDetails?.redirectType ??
        RedirectOtherFundraiserType.ClosestGoal,
      redirectWebsiteUrl:
        data.donationAndPaymentDetails?.redirectValue?.url ?? "",
      redirectMobilePage:
        data.donationAndPaymentDetails?.redirectValue?.id ?? "",
      redirectOtherFundraiserType: RedirectOtherFundraiserType.ClosestGoal,
      //redirectSpecificFundraiserId: data.redirectSpecificFundraiserId ?? "",
      status: data.status ?? "Draft",
      startDate: data.startDate ? new Date(data.startDate) : new Date(),
      endDate: data.endDate ? new Date(data.endDate) : new Date(),
      createdDate: data.createdDate ? new Date(data.createdDate) : undefined,
      lastDonation: data.lastDonatedOn
        ? new Date(data.lastDonatedOn)
        : undefined,
      impact:
        data.impacts?.map((i, index) =>
          ImpactModel.deserializeAPIModel(i, index)
        ) ?? [],
      rewards:
        data.marketing?.rewardsByAmount?.map((r, idx) =>
          RewardModel.deserializeAPIModel(r, idx)
        ) ?? [],
      ranks:
        data.marketing?.rewardByRank?.map((rk, idx) =>
          RankAchievementModel.deserializeAPIModel(rk, idx)
        ) ?? [],
      layoutData: data.design
        ? LayoutDataModel.deserializeAPIModel(data.design)
        : undefined,
      donationAndPaymentDetails: data.donationAndPaymentDetails
        ? DonationAndPaymentModel.deserializeAPIModel(
            data.donationAndPaymentDetails
          )
        : undefined,
      leaderboard: data.leadboard?.map((l) =>
        PromoterProgressModel.deserializeAPIModel(l, data.id)
      ),
      donationsBoard: data.donations?.map((d) =>
        FundraisersDonationsBoardResponse.deserializeAPIModel(d)
      ),
      stats:
        data.stats?.map((s, idx) =>
          FundRaiserStatsModel.deserializeAPIModel(s, idx)
        ) || [],
    });
  }

  static deserializeGridAPIModel(data: IAPIFundraiserGridModel): Fundraiser {
    return new Fundraiser({
      id: data.id ? data.id : "",
      createdDate: data.createdDate ? new Date(data.createdDate) : undefined,
      name: data.name,
      status: data.status,
      goal: data.goalAmount,
      currentAmount: data.totalRaisedAmount,
      activePromoters: data.totalPromoters,
      totalDonations: data.totalDonations,
      lastDonation: data.lastDonatedOn
        ? new Date(data.lastDonatedOn)
        : undefined,
      mediaItems:
        data.medias?.map((m) => MediaModel.deserializeAPIModel(m)) || [],
      startDate: data.startDate ? new Date(data.startDate) : undefined,
      endDate: data.endDate ? new Date(data.endDate) : undefined,
      titleIcon: data.icon ?? undefined,
      fundraiserImage: data.image
        ? MediaModel.deserializeAPIModel(data.image)
        : undefined,
      iconImageChoice: (data.iconType as keyof typeof IconType) ?? "None",
      titleColor: data.color
        ? ColorModel.deserializeAPIModel(data.color)
        : undefined,
    });
  }

  static deserializeCreateFundraiserModel(
    data: Fundraiser
  ): CreateFundraiserModel {
    return new CreateFundraiserModel({
      id: data.id,
      name: data.name,
      title: data.title,
      subtitle: data.subtitle,
      description: data.description,
      pageName: data.pageName,
      goal: data.goal,
      startDate: data.startDate,
      endDate: data.endDate,
      status: data.status,
      category: data.category
        ? new CategoryModel({ id: data.category }) // adapt if category is richer
        : new CategoryModel(),
      iconImageChoice: data.iconImageChoice ?? IconType.None,
      titleIcon: data.titleIcon ?? "",
      titleColor: data.titleColor ?? new ColorModel({ hex: "#000000" }),
      fundraiserImage: data.fundraiserImage ?? new MediaModel(),
      mediaItems: data.mediaItems ?? [],
      rewards: data.rewards ?? [],
      ranks: data.ranks ?? [],
      impact: data.impact ?? [],
      fundraiserStats: data.stats ?? [],
      bannerImage: data.fundraiserImage ?? new MediaModel(),
      closeOnGoalAchieved: data.closeOnGoalAchieved ?? false,
      increaseGoalOnAchieved: data.increaseGoalOnAchieved ?? false,
      redirectOnVisit: data.redirectOnVisit
        ? (FundRaiserRedirectType[data.redirectOnVisit] ??
          FundRaiserRedirectType.None)
        : FundRaiserRedirectType.None,
      redirectWebsiteUrl: data.redirectWebsiteUrl ?? "",
      redirectMobilePage: data.redirectMobilePage ?? "",
      redirectOtherFundraiserType:
        data.redirectOtherFundraiserType ??
        RedirectOtherFundraiserType.ClosestGoal,
      redirectSpecificFundraiserIds: data.redirectSpecificFundraiserId
        ? [data.redirectSpecificFundraiserId]
        : [],
      activePromoters: data.activePromoters ?? 0,
      totalDonations: data.totalDonations ?? 0,
      totalDonors: data.totalDonars ?? 0,
      createdDate: data.createdDate,
      lastDonatedOn: data.lastDonation,
      donationsBoard: data.donationsBoard,
      leaderboard: data.leaderboard,
    });
  }
}

export class FundraiserStatsModel {
  id: string;
  label: string;
  value: string;
  order: number;
  constructor(data?: Partial<FundraiserStatsModel>) {
    this.id = data?.id ?? "";
    this.label = data?.label ?? "";
    this.value = data?.value ?? "";
    this.order = data?.order ?? 0;
  }
  static deserializeAPIModel(data: FundraiserStatsModel): FundraiserStatsModel {
    return new FundraiserStatsModel(data);
  }
}
